import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@material-ui/core';

import * as getTime from '~/skills/getTime';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';

import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_Select, EAA_BottomBtn } from '~/components/EditAndAddItem';

import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';

import Sub1 from './Sub1';
import Sub2 from './Sub2';
import Sub3 from './Sub3';
import Sub4 from './Sub4';

const modeInfo = {
  add: {
    title: '製造業(辦理中)_新增',
  },
  edit: {
    title: '製造業(辦理中)_編輯',
  },
  view: {
    title: '製造業(辦理中)_檢視',
  },
};
const titleWidth = 150;
const errorLeft = titleWidth + 20;

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }

  componentDidMount () {
    const { id, getIAManufacturingProcessIdDetail, getBaseData, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getIAManufacturingProcessIdDetail(id);
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { IAManufacturingProcessIdDetail: preIAManufacturingProcessIdDetail = {} } = preProps;
    const { IAManufacturingProcessIdDetail = {}, mode } = this.props;
    if (Object.keys(preIAManufacturingProcessIdDetail).length === 0 && Object.keys(IAManufacturingProcessIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: IAManufacturingProcessIdDetail, old_data: IAManufacturingProcessIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('IAManufacturingProcessIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      wind_mechine_mw: data.wind_mechine_mw || '',
      wind_mechine_num: data.wind_mechine_num || '',
      project: data.project || '',
      detailitem: data.detailitem || '',
      apply_change_num: data.apply_change_num || '',
      change_desc: data.change_desc || '',
      local_method: data.local_method || '',
      local_method_upload_files: data.local_method_upload_files || [],
      get_agree_doc: data.get_agree_doc || '',
      review_agree_date: data.review_agree_date || '',
      review_agree_docnum: data.review_agree_docnum || '',
      review_agree_upload_files: data.review_agree_upload_files || [],
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: data.sub3 || [],
      sub4: data.sub4 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewIAManufacturingProcessData(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });

  edit=(status = {}) => {
    const { id, putIAManufacturingProcessData } = this.props;
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    putIAManufacturingProcessData(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.wind_mechine_mw) === '', // 0 風力機單位容量
      returnInputValue(data.wind_mechine_num) === '', // 1 風力機組數
      returnInputValue(data.project) === '', // 2 項目
      returnInputValue(data.detailitem) === '', // 3 細項
      returnInputValue(data.change_desc) === '', // 4 變更說明
      returnInputValue(data.local_method) === '', // 5 額外在地化方案 條列式詳答
      (data.local_method_upload_files || []).length === 0, // 6 額外在地化方案 上傳檔案
      returnInputValue(data.get_agree_doc) === '', // 7 是否取得經濟部變更同意函
      returnInputValue(data.review_agree_date) === '', // 8 經濟部變更同意函 發文日期
      returnInputValue(data.review_agree_docnum) === '', // 9 經濟部變更同意函 公文文號
      (data.review_agree_upload_files || []).length === 0, // 10 經濟部變更同意函 公文上傳
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const {
      mode = '',
      IAMMItemList = [],
    } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    // const { status = '0' } = data;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const allRight = errorAry.indexOf(true) === -1;

    const returnIdList = value => {
      for (const o of IAMMItemList) {
        if (value === o.value) return o.idList;
      }
      return [];
    }; const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };

    return (
      <div style={{ width: '80%', maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column', padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='風力機單機容量' bol haveChange={checkChange('wind_mechine_mw')} />
              <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數字' unit='MW' value={returnInputValue(data.wind_mechine_mw)} onChange={data => this.changeData({ label: 'wind_mechine_mw', data })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='風力機組數' bol haveChange={checkChange('wind_mechine_num')} />
              <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數字' unit='座' value={returnInputValue(data.wind_mechine_num)} onChange={data => this.changeData({ label: 'wind_mechine_num', data })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='項目' bol haveChange={checkChange('project')} />
              <EAA_Select displayBorder disabled={disabled} list={IAMMItemList} value={returnInputValue(data.project)} onChange={data => this.changeData({ label: 'project', data }, () => this.changeData({ label: 'detailitem', data: '' }))} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='細項' bol haveChange={checkChange('detailitem')} />
              <EAA_Select displayBorder disabled={disabled || returnIdList(data.project).length === 0} list={returnIdList(data.project)} value={returnInputValue(data.detailitem)} onChange={data => this.changeData({ label: 'detailitem', data })} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='本次申請變更數量' haveChange={checkChange('apply_change_num')} />
              <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數字' value={returnInputValue(data.apply_change_num)} onChange={data => this.changeData({ label: 'apply_change_num', data })} />
            </EAA_ItemContainer>
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <SearchBar style={{ marginTop: 20 }} defaultOpen forceOpen={returnForceOpen({ least: 4, most: 10 })}>
          <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='變更說明' bol haveChange={checkChange('change_desc')} />
                <EAA_Input displayBorder disabled={disabled} hint='詳答：原數量56座調整為18座 或原進口8座半成品改為10座全' value={returnInputValue(data.change_desc)} onChange={data => this.changeData({ label: 'change_desc', data })} />
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>

          <Sub2 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='額外在地化方案' bol haveChange={checkChange('local_method')} />
                <EAA_Memo displayBorder disabled={disabled} hint='條列式詳答' marginRight={12} value={returnInputValue(data.local_method)} onChange={data => this.changeData({ label: 'local_method', data })} />
                <EAA_Upload displayBorder disabled={disabled} value={data.local_method_upload_files || []} onChange={data => this.changeData({ label: 'local_method_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請詳答' />}
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
            </EAA_Item>
          </EAA_Row>

          <Sub3 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <Sub4 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='是否取得經濟部變更' subtitle='同意函' subtitleColor='black' bol haveChange={checkChange('get_agree_doc')} />
                <div style={{ flex: 1, marginRight: 12, display: 'flex' }}>
                  <CircleCheckBox disabled={disabled} value={data.get_agree_doc === '1'} onClick={() => this.changeData({ label: 'get_agree_doc', data: '1' })} />
                  <div style={{ marginRight: 8 }}>已取得</div>
                  <CircleCheckBox disabled={disabled} value={data.get_agree_doc === '2'} onClick={() => this.changeData({ label: 'get_agree_doc', data: '2' })} />
                  <div>尚未取得</div>
                </div>
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='' />
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>(公文)發文日期</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>公文文號</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 50 }}>公文上傳(含附件)</div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>

          <EAA_Row style={{ marginTop: 0 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='經濟部變更同意函' bol haveChange={checkChange('review_agree_date') || checkChange('review_agree_docnum')} />
                <EAA_Date displayBorder disabled={disabled} marginRight={12} value={getTime.returnDate(data.review_agree_date)} onChange={data => this.changeData({ label: 'review_agree_date', data: getTime.getType3Time(data) })} />
                <EAA_Input displayBorder disabled={disabled} marginRight={12} value={returnInputValue(data.review_agree_docnum)} onChange={data => this.changeData({ label: 'review_agree_docnum', data })} />
                <EAA_Upload displayBorder disabled={disabled} value={data.review_agree_upload_files || []} onChange={data => this.changeData({ label: 'review_agree_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『文號』' />}
              {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳公文' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewIAManufacturingProcessData' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutIAManufacturingProcessData' />
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  IAManufacturingProcessIdDetail: state.data.IAManufacturingProcessIdDetail,

  IAMMItemList: state.data.IAMMItemList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: id => {
    Actions_Wind.getIAMMItemList(dispatch);
  },
  getIAManufacturingProcessIdDetail: id => Actions_Wind.getIAManufacturingProcessIdDetail(dispatch, { id }),
  postAddNewIAManufacturingProcessData: body => Actions_Wind.postAddNewIAManufacturingProcessData(dispatch, { body }),
  putIAManufacturingProcessData: (id, body) => Actions_Wind.putIAManufacturingProcessData(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
